import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig, countries, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the FilterReferralsAwardsReportsView.
 * @extends JetView
 */
export default class FilterReferralsAwardsReportsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service

        // Left section containing filters
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text', // Text input for Jackpot ID
                            name: 'JackpotId',
                            id: 'JackpotId',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Jackpot'),
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Jackpot'),
                        },
                        {
                            view: 'text', // Text input for Player ID
                            name: 'PlayerId',
                            id: 'PlayerId',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Jugador'),
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Jugador'),
                        },
                        {
                            view: 'text', // Text input for Drop Date
                            minWidth: 200,
                            name: 'DropDate',
                            id: 'DropDate',
                            css: 'reportrange',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de caída'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'richselect', // Dropdown for Balance Type
                            name: 'BalanceType',
                            id: 'BalanceType',
                            label: _('Tipo de saldo'),
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '),
                            value: '0',
                            options: [
                                { id: '0', value: _('Todos') },
                                { id: '1', value: _('Saldo Recargas') },
                                { id: '2', value: _('Saldo Retiros') },
                            ],
                        },
                    ],
                },
            ],
        };

        // Additional left section with more filters
        const left3 = {
            margin: 5,
            id: 'a3',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a3',
                    cols: [
                        {
                            view: 'text', // Text input for Jackpot Name
                            name: 'JackpotName',
                            type: 'text',
                            id: 'JackpotName',
                            label: "<span class='icon-drivers-license-o'></span>" + _('Nombre'),
                            labelPosition: 'top',
                            placeholder: _('Nombre'),
                        },
                        {
                            view: 'richselect', // Dropdown for Vertical
                            name: 'Vertical',
                            id: 'Vertical',
                            label: _('Vertical'),
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '),
                            value: '0',
                            options: [
                                { id: '0', value: _('Todas') },
                                { id: '1', value: _('Deportivas') },
                                { id: '2', value: _('Casino') },
                                { id: '3', value: _('Casino en vivo') },
                                { id: '4', value: _('Virtuales') },
                            ],
                        },
                        {
                            view: 'richselect', // Dropdown for Country selection
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            minWidth: 200,
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'richselect', // Read-only dropdown for Country selection
                            name: 'CountrySelect2',
                            minWidth: 200,
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: profile.Settings.ReportCountry,
                            readonly: true,
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            hidden: !devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByCountry country-hide',
                        },
                        {},
                    ],
                },
            ],
        };

        // Upper section containing both left sections
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // First left section
                },
                {
                    margin: 10,
                    cols: [left3], // Second left section
                },
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'),
                    width: 100,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                        $$('CountrySelect').setValue($$('myForm').getCleanValues().CountrySelect);
                        $$('JackpotId').setValue(''); // Clear Jackpot ID
                        $$('PlayerId').setValue(''); // Clear Player ID
                        $$('DropDate').setValue(''); // Clear Drop Date
                        $$('BalanceType').setValue('0'); // Reset Balance Type
                        $$('JackpotName').setValue(''); // Clear Jackpot Name
                        $$('Vertical').setValue('0'); // Reset Vertical
                        $$('CountrySelect').setValue(''); // Clear Country Select
                        if (devConfig.getCountryReport()) {
                            $$('CountrySelect2').setValue(
                                profile.Settings.ReportCountry, // Reset Country Select 2 if applicable
                            );
                        }
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'),
                    type: 'form',
                    width: 110,
                    id: 'consultDesk',
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set Country Select if applicable
                        }
                        delete filterdata['CountrySelect2']; // Remove Country Select 2 from filter data
                        this.app.callEvent('casinoReport:filter', [filterdata]); // Trigger filter event
                        $$('b5').collapse(); // Collapse the filter section
                        $$('a5').scrollTo(100, 0); // Scroll to a specific position
                    },
                },
            ],
        };

        // Second button section for actions
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button', // Clear button for second form
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues()); // Reset second form values
                        $$('CountrySelect').setValue($$('myForm2').getCleanValues().CountrySelect);
                        $$('DateStart').setValue(''); // Clear Date Start
                        $$('DateEnd').setValue(''); // Clear Date End
                    },
                },
                {
                    view: 'button', // Consult button for second form
                    value: _('Consultar'),
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get second form values
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set Country Select if applicable
                        }
                        delete filterdata['CountrySelect2']; // Remove Country Select 2 from filter data
                        this.app.callEvent('casinoReport:filter', [filterdata]); // Trigger filter event
                        $$('b5').collapse(); // Collapse the filter section
                        $$('a5').scrollTo(100, 0); // Scroll to a specific position
                    },
                },
            ],
        };

        // Accordion section for filters
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Content of the accordion
                            },
                        },
                    ],
                },
            ],
        };

        // Scrollable section for filters
        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Content of the scrollable section
            },
        };

        // Popup window for filters
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Title of the popup
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Content of the popup
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });

        // Main form configuration
        return {
            view: 'form',
            id: 'myForm',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion if screen size is sufficient
                    : { height: 1, width: 0 }, // Placeholder for small screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object passed to the init method.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('DropDate').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
        webix.ready(function () {
            if (screen.width < 500) {
                // Additional logic for small screens can be added here
            }
            if (profile.typeDate !== 2) {
                $$('DropDate').show(); // Show Drop Date if condition is met
            } else {
                if (true) {
                    $$('DropDate').hide(); // Hide Drop Date if condition is met
                }
            }
        });
    }
}

// FILE DOCUMENTED
